const About = {
    sub: "about.sub",
    heading: "about.heading",
    description: "about.description",
    experience: {
        years: 1810,
        text: "about.experience.text"
    },
    points: [
        'about.points.0',
        'about.points.1',
        'about.points.2',
        'about.points.3'
    ],
    button: {
        text: "about.button.text",
        link: 'Historia'
    },

    presidentLetter: {
        title: "about.presidentLetter.title",
        content: [
            "about.presidentLetter.content.0",
            "about.presidentLetter.content.1",
            "about.presidentLetter.content.2",
            "about.presidentLetter.content.3",
            "about.presidentLetter.content.4",
            "about.presidentLetter.content.5",
            "about.presidentLetter.content.6"
        ],
        closing: "about.presidentLetter.closing",
        signature: "mgr inż. Mariusz Gądziak",
        role: "about.presidentLetter.role"
    },
    manifest: {
        title: "about.manifest.title",
        subtitle: "about.manifest.subtitle",
        beliefs: [
            "about.manifest.beliefs.0",
            "about.manifest.beliefs.1",
            "about.manifest.beliefs.2",
            "about.manifest.beliefs.3",
            "about.manifest.beliefs.4"
        ],
        conclusion: [
            "about.manifest.conclusion.0",
            "about.manifest.conclusion.1",
            "about.manifest.conclusion.2",
            "about.manifest.conclusion.3"
        ]
    }
}

export default About;